import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Gimnasio = {
  id: string;
  nombre: string;
  slug: string;
  estado: string;
  plan_saas: string;
  created_at: string;
  updated_at: string;
};

export type UsuarioAdmin = {
  id: string;
  auth_id: string;
  email: string;
  nombre: string;
  role: 'platform_admin' | 'gym_admin' | 'staff' | 'admin';
  gimnasio_id: string | null;
  sucursal_id: string | null;
  activo: boolean;
  created_at: string;
  updated_at: string;
};

export type Usuario = {
  id: string;
  auth_id?: string | null;
  gimnasio_id?: string | null;
  nombre: string;
  email: string;
  telefono: string;
  whatsapp: string;
  fecha_nacimiento: string;
  tipo_membresia: string;
  fecha_inicio: string;
  fecha_vencimiento: string;
  estado: 'activo' | 'inactivo' | 'vencido';
  sucursal_id: string;
  notificar_email: boolean;
  notificar_whatsapp: boolean;
  created_at: string;
  updated_at: string;
};

export type Horario = {
  id: string;
  gimnasio_id?: string | null;
  nombre_clase: string;
  instructor: string | null;
  dia_semana: string;
  hora_inicio: string;
  hora_fin: string;
  capacidad_maxima: number;
  sucursal_id: string;
  activo: boolean;
  created_at: string;
  updated_at: string;
};
